import { FC } from "react";
import { InputProps, GroupBase, components } from "react-select";
import SelectOption from "../option/select-option";

type SelectInputProps = InputProps<
  SelectOption,
  false,
  GroupBase<SelectOption>
> & {
  idForTesting: string | undefined;
};

const SelectInputComponent: FC<SelectInputProps> = (props) => {
  const { idForTesting, ...propsRest } = props;

  const Input = components.Input as React.ComponentType<
    InputProps<SelectOption, false, GroupBase<SelectOption>>
  >;

  return (
    <Input
      {...Object.assign({}, propsRest, {
        "data-test-id": idForTesting,
      })}
    />
  );
};

export default SelectInputComponent;
